<template>
     <div class="carOrderItem-room">
        <div class="carOrderItem-room-checkbox">
            <div class="carOrderItem-room-icon js-carOrderItemRoomIcon" :class="{ active: isSelected}" @click="onStateroomSelected(shoppingCarts)">
                <img src="https://resource.rcclchina.com.cn/tui2/packageGuestInfo/icon10.png">
            </div>
        </div>
        <div class="carOrderItem-room-m">
            <div class="carOrderItem-room-img js-carOrderItemRoomIcon">
                <img :class="GlobalData.groupTypeValues[shoppingCart.groupType]"
                    :src="shoppingCart.stateroomPartRecord ? shoppingCart.stateroomPartRecord.desImage : ''">
                <img class="pcp-gift-icon"
                     v-if="shoppingCart.groupType === 'PCPGIFT'"
                     :src="personalizedStateroomInfo?.roomIconImage"
                     :alt="shoppingCart.groupType"
                />
            </div>
            <div class="carOrderItem-room-box">
                <div class="carOrderItem-room-box-delete" @click="onDeleteByStateroom(shoppingCarts)">
                    <img src="https://resource.rcclchina.com.cn/tui2/packageGuestInfo/icon12.png">
                </div>
                <div class="carOrderItem-room-box-name">{{stateroomName}}</div>
                <div class="carOrderItem-room-box-info">
                  <span>{{ stateroom.areaInfo }}</span
                    ><span>{{ stateroomBalcony }}</span
                    ><span>{{ stateroom.floorInfo }}</span>
                </div>
                <template v-if="stateroom.stateroomClassPartRecord.stateroomType === 'DELUXE'">
<!--                  <DeviceFeatureTags is-detail is-detail-txt-cart :tags="shoppingCart.featureDeviceTags" :view-num="2" @submit="onStateroomClicked($event)"></DeviceFeatureTags>-->
                  <DeviceFeatureTags is-detail is-detail-txt-cart :view-num="2" @submit="onStateroomClicked($event)"></DeviceFeatureTags>
                </template>
                <template v-else>
<!--                  <DeviceFeatureTags is-detail is-detail-txt-cart :tags="shoppingCart.featureDeviceTags" @submit="onStateroomClicked($event)"></DeviceFeatureTags>-->
                  <DeviceFeatureTags is-detail is-detail-txt-cart @submit="onStateroomClicked($event)"></DeviceFeatureTags>
                </template>
                <div v-if="isQiaohu">
                    <img class="QIAOHU_CSS qiaohu_tag" @click="showQiaohuPopup" src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                </div>
                <div v-else-if="isStarrySky">
                  <img class="STARRYSKY_CSS" @click="showStarrySkyPopup" src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                </div>
                <div v-else-if="isPcpGiftTheme">
                  <img class="PCP_GIFT_THEME_CSS" @click="showCustomThemePopup(personalizedStateroomInfo)"
                       :src="personalizedStateroomInfo?.roomTransparentIconImage">
                </div>
                <div v-else-if="isCustomTheme">
                  <img class="CUSTOM_THEME_CSS" @click="showCustomThemePopup(personalizedStateroomInfo)" :src="personalizedStateroomInfo?.roomIconImage">
                </div>
                <div class="carOrderItem-room-box-txt2" style="margin-top: 10px">
                    <div class="carOrderItem-room-box-price">
                        <div class="carOrderItem-room-box-price-txt3">{{getPriceType(shoppingCart)}}(含税)：</div>
                        <div class="carOrderItem-room-box-price-txt1">¥</div>
                        <div class="carOrderItem-room-box-price-txt2">{{shoppingCart.netAmount > 0 ? shoppingCart.netAmount.toFixed(0): ''}}</div>
                        <div class="carOrderItem-room-box-price-txt3">/人起</div>
                    </div>
                </div>
                <div v-if="shoppingCart.amountPerNight" class="desc_per_night">平均每晚￥{{shoppingCart.amountPerNight}}/人起</div>
<!--                <div class="carOrderItem-room-box-txt2">-->
<!--                    <div class="carOrderItem-room-box-origin-price">-->
<!--                        <div class="carOrderItem-room-box-price-txt3">零售指导价(含税)：¥{{shoppingCart.originAmount > 0 ? shoppingCart.originAmount.toFixed(0): ''}}/人起</div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="carOrderItem-room-box-txt2 carOrderItem-room-box-btns">
                    <div class="carOrderItem-room-box-nrpType unsubscribeOpenBtn">{{getNrpTitle(shoppingCart)}}</div>
                    <div class="carOrderItem-room-box-count">
                        <div class="carOrderItem-room-box-count-minus js-minus" @click="deleteShoppingCart(shoppingCart)"></div>
                        <div class="carOrderItem-room-box-count-num">{{count}}</div>
                        <div class="carOrderItem-room-box-count-plus js-plus" @click="onAddShoppingCart(shoppingCart)"></div>
                    </div>
                </div>
            </div>
        </div>
       <!-- 舱房详情 -->
    </div>
</template>

<script>
import nrpConfig from '@/utilities/nrpConfig'
const DeviceFeatureTags = ()=> import("@/components/Cruise/DeviceFeatureTags");
export default {
    name: "ShoppingCartStateroom",
    components: {
      DeviceFeatureTags
    },
    props: {
        shoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        selectedShoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        onStateroomSelected: {
            type: Function
        },
        onAddShoppingCart: {
            type: Function
        },
        onDeleteShoppingCart: {
            type: Function
        },
        onDeleteByStateroom: {
            type: Function
        },
        showQiaohuPopup: {
            type: Function
        },
        showStarrySkyPopup: {
          type: Function
        },
        showCustomThemePopup: {
          type: Function
        }
    },
    methods: {
        deleteShoppingCart (shoppingCart) {
            if (this.count == 1) {
                this.$alert.show('受不了了，舱房不能再减少了哦！')
                return
            }
            this.onDeleteShoppingCart(shoppingCart)
        },
        getPriceType (shoppingCart) {
            if (shoppingCart.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.priceType
            }
            return shoppingCart.isnrp ? nrpConfig.nrp.priceType: nrpConfig.rp.priceType
        },
        getNrpTitle (shoppingCart) {
            if (shoppingCart.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.title
            }
            return shoppingCart.isnrp ? nrpConfig.nrp.title: nrpConfig.rp.title
        },
        onStateroomClicked(e) {
          console.log(e)
          e.stopPropagation();
          let shoppingCart = this.shoppingCart;
          let stateroomPartRecord = this.stateroom;
          const stateroomData = {
            stateroomImages: stateroomPartRecord.stateroomImages || null,
            stateroomName: stateroomPartRecord.cnName,
            stateroomCategory: stateroomPartRecord.stateroomCategoryCode,
            stateroomPriceType: this.priceType,
            stateroomPrice: shoppingCart.netAmount,
            stateroomCapacity: stateroomPartRecord.capacity,
            stateroomArea: stateroomPartRecord.areaInfo,
            stateroomBalcony: stateroomPartRecord.balconyAreaInfo,
            stateroomFloor: stateroomPartRecord.floorInfo,
            isQiaohu: this.isQiaohu,
            isStarrySky: this.isStarrySky,
            isPcpGiftTheme: this.isPcpGiftTheme,
            isCustomTheme: this.isCustomTheme,
            stateroomDescription: stateroomPartRecord.description,
            stateroomNrpTitle: this.nrpTitle,
            stateroomNrpText: this.nrpText,
            suiteImageUrl: stateroomPartRecord.suiteImageUrl,
            suiteMobileImageUrl: stateroomPartRecord.suiteMobileImageUrl,
            suiteType: stateroomPartRecord.suiteType,
            stateroomType: shoppingCart.stateroomType,
            personalizedStateroomInfo: this.personalizedStateroomInfo,
            // deviceFeatureTags: shoppingCart.featureDeviceTags,
            deviceGroupTags: shoppingCart.deviceTags,
            stateroomImageDataList: shoppingCart.stateroomImageDataList,
            roomSummaryList: shoppingCart.roomSummaryList || [],
            suiteRightsCount: shoppingCart.suiteRightsCount
          };
          this.$emit('detail', stateroomData);
        }
    },
    computed: {
        shoppingCart () {
            if (!this.shoppingCarts || this.shoppingCarts.length == 0) {
                return {}
            }
            console.log('123123', this.shoppingCarts[this.shoppingCarts.length - 1])
            return this.shoppingCarts[this.shoppingCarts.length - 1]
        },
        count () {
            return this.shoppingCarts.length
        },
        isSelected () {
            const shoppingCart = this.shoppingCart
            return this.selectedShoppingCarts
            .some(r=>r.berthedCategoryCode == shoppingCart.berthedCategoryCode
                && r.isnrp == shoppingCart.isnrp
                && r.groupType == shoppingCart.groupType)
        },
        isQiaohu () {
            const shoppingCart = this.shoppingCart
            return shoppingCart.groupType == 'QIAOHU'
        },
        isStarrySky () {
          const shoppingCart = this.shoppingCart
          return shoppingCart.groupType == 'STARRYSKY'
        },
        isPcpGiftTheme() {
          const shoppingCart = this.shoppingCart
          return shoppingCart.groupType == 'PCPGIFT'
        },
        isCustomTheme () {
          const shoppingCart = this.shoppingCart
          return shoppingCart.groupType == 'CUSTOM'
        },
        personalizedStateroomInfo() {
          const shoppingCart = this.shoppingCart
          return shoppingCart.bookingShoppingCart.stateroomPartViewModel.personalizedStateroomInfo
        },
        stateroom () {
            const shoppingCart = this.shoppingCart
            if (!shoppingCart.stateroomPartRecord) {
                return {}
            }
            return shoppingCart.stateroomPartRecord
        },
        stateroomName () {
            if (!this.stateroom.stateroomCategoryCode) return ''
            let name = this.stateroom.cnName
            let code = this.stateroom.stateroomCategoryCode
            if (code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            return `${name}_${code}`
        },
        stateroomBalcony () {
            const balcony = this.stateroom.balconyAreaInfo
            if (!balcony || balcony == '' || balcony == '无') {
                return '无阳台'
            }
            return balcony
        },
        priceType() {
          if (this.shoppingCart.isFortyEightHoursNrpCruise) {
            return nrpConfig.fortyEightHoursNrp.priceType;
          } else if (this.shoppingCart.isnrp) {
            return nrpConfig.nrp.priceType;
          }
          return nrpConfig.rp.priceType;
        },
        nrpTitle() {
          if (this.shoppingCart.isFortyEightHoursNrpCruise) {
            return nrpConfig.fortyEightHoursNrp.title;
          } else if (this.shoppingCart.isnrp) {
            return nrpConfig.nrp.title;
          }
          return nrpConfig.rp.title;
        },
        nrpText() {
          if (this.shoppingCart.isFortyEightHoursNrpCruise) {
            return nrpConfig.fortyEightHoursNrp.description;
          } else if (this.shoppingCart.isnrp) {
            return nrpConfig.nrp.description;
          } else {
            return nrpConfig.rp.description;
          }
        },
    }
}
</script>

<style lang="less" scoped>
img {
    max-width: 100%;
}
.carOrderItem-room {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 15px 0 14px;
    border-bottom: 1px solid #CCCCCC;
    .carOrderItem-room-checkbox {
        position: relative;
        width: 40px;
        margin-left: -20px;
        padding-left: 20px;
        .carOrderItem-room-icon {
            -webkit-box-flex: 0;
            -webkit-flex: none;
            -moz-box-flex: 0;
            -ms-flex: none;
            flex: none;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            margin-top: 3px;
            border: 1px solid #4A90E2;
            border-radius: 100%;
            img {
                display: none;
                width: 12px;
            }
        }
        .carOrderItem-room-icon.active {
            background-color: #4A90E2;
            img {
                display: block;
            }
        }
    }

    .carOrderItem-room-m {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        .carOrderItem-room-img {
            position: relative;
            -webkit-box-flex: 0;
            -webkit-flex: none;
            -moz-box-flex: 0;
            -ms-flex: none;
            flex: none;
            width: 100px;
            margin-right: 10px;
            & .pcp-gift-icon {
              position: absolute;
              top: 5px;
              left: 50%;
              margin-left: -30px;
              width: 60px;
            }
        }
        .carOrderItem-room-box {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            position: relative;
            & .desc_per_night {
              line-height: 18px;
              letter-spacing: -1px;
              font-size: 12px;
              margin-top: 1px;
              color: #a6aeb1;
            }
            .carOrderItem-room-box-delete {
                position: absolute;
                top: 3px;
                right: 0;
                z-index: 2;
                width: 30px;
                height: 30px;
                padding-left: 15px;
                padding-bottom: 15px;
            }
            .carOrderItem-room-box-name {
                padding-right: 30px;
                padding-bottom: 3px;
                font-size: 14px;
                line-height: 20px;
                color: #333;
                font-weight: bold;
            }
            .carOrderItem-room-box-info {
                padding-bottom: 0;
                font-size: 12px;
                line-height: 12px;
                color: #666;
                letter-spacing: -1px;
                span {
                  display: inline-block;
                }
                span + span {
                  margin-left: 7px;
                  padding-left: 7px;
                  border-left: 1px solid #979797;
                }
            }
            .carOrderItem-room-box-price {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                .carOrderItem-room-box-price-txt3 {
                    font-size: 10px;
                    line-height: 1;
                    color: #666;
                }
                .carOrderItem-room-box-price-txt1 {
                    font-size: 12px;
                    line-height: 1;
                    color: #FF5055;
                }
                .carOrderItem-room-box-price-txt2 {
                    margin-right: 3px;
                    font-size: 18px;
                    line-height: 1;
                    color: #FF5055;
                    font-weight: bold;
                }
            }
            .carOrderItem-room-box-origin-price {
                margin-top: 4px;
                .carOrderItem-room-box-price-txt3 {
                    color: #aaa;
                    text-decoration: line-through;
                    font-size: 10px;
                    line-height: 1;
                }
            }
            .carOrderItem-room-box-btns {
                margin-top: 8px;
                .carOrderItem-room-box-nrpType {
                    float: left;
                    background: #FEBC10;
                    border-radius: 4px;
                    color: white;
                    font-size: 11px;
                    padding: 0 9px;
                    margin-top: 4px;
                    display: inline-block;
                }
                .carOrderItem-room-box-count {
                    -webkit-box-flex: 0;
                    -webkit-flex: none;
                    -moz-box-flex: 0;
                    -ms-flex: none;
                    flex: none;
                    position: relative;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -moz-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    float: right;
                    position: relative;
                    top: 3px;
                    .carOrderItem-room-box-count-minus {
                        position: relative;
                        width: 21px;
                        height: 21px;
                        border: 1px solid #4A90E2;
                        border-radius: 100%;
                    }
                    .carOrderItem-room-box-count-minus:before {
                        content: '';
                        display: block;
                        position: absolute;
                        left: 4px;
                        top: 9px;
                        width: 11px;
                        height: 1px;
                        background-color: #4A90E2;
                    }
                    .carOrderItem-room-box-count-num {
                        width: 28px;
                        font-size: 15px;
                        line-height: 21px;
                        color: #000;
                        text-align: center;
                    }
                    .carOrderItem-room-box-count-plus {
                        position: relative;
                        width: 21px;
                        height: 21px;
                        border: 1px solid #FEBC10;
                        background-color: #FEBC10;
                        border-radius: 100%;
                    }
                    .carOrderItem-room-box-count-plus:before {
                        content: '';
                        display: block;
                        position: absolute;
                        left: 4px;
                        top: 9px;
                        width: 11px;
                        height: 1px;
                        background-color: #fff;
                    }
                    .carOrderItem-room-box-count-plus:after {
                        content: '';
                        display: block;
                        position: absolute;
                        left: 9px;
                        top: 4px;
                        width: 1px;
                        height: 11px;
                        background-color: #fff;
                    }
                }
            }
        }
    }


    .QIAOHU_CSS {
      display: block;
      height: 18px;
      margin-top: 5px;
    }
    .QIAOHU_BACKGROUND_CSS {
      border: 2px solid #FFE100;
    }
    .STARRYSKY_BACKGROUND_CSS {
      border: 2px solid #FFE100;
    }
    .CUSTOM_BACKGROUND_CSS {
      border: 2px solid #ffe100;
    }
    .PCP_GIFT_BACKGROUND_CSS {
      border: 2px solid #ffe100;
    }
    .STARRYSKY_CSS {
      display: block;
      height: 18px;
      margin-top: 5px;
    }
    .PCP_GIFT_THEME_CSS {
      display: block;
      height: 23px;
      margin-top: 5px;
    }
    .CUSTOM_THEME_CSS {
      display: block;
      height: 18px;
      margin-top: 5px;
    }
}
.carOrderItem-room:last-child {
    border-bottom: none;
}
</style>
